export default __webpack_public_path__ + "static/media/70px-Headshot.190a6569.png";